<template>
    <div class="population-view">
        <PopulationList
            v-if="overview && overview.schedule"
            :patient-list="patientList"
            :list-title="listTitle"
            :url="url"></PopulationList>
        <PopulationList
            v-else
            :patient-list="[]"
            :list-title="''"
            :loading-show="true"
            :url="url"></PopulationList>
        <div class="detail">
            <router-view
                v-bind:url="url"
                v-bind:print="null">
                </router-view>
            </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import formatUrlSafe from '@/module/util/format-url-safe';

import PopulationList from '@/module/population/list/List'

const upcomingList = ['today', 'tommorrow', 'next_seven']
const previousList = ['last_seven', 'last_fourteen']

export default {
    name: 'upcoming-population',

    props: {
        direction: {
            type: String,
            default: 'forward'
        },
        location: {
            type: String,
            // required: true
        },
        event: {
            type: String,
            // required: true
        }
    },

    data() {
        return {
            timeRange: [],
            providerFilter: [],
            locationFilter: [],
            eventFilter: [],
        }
    },

    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                const { query } = to
                this.timeRange = query.timeRange ? query.timeRange.split(',') : []
                this.providerFilter = query.provider ? query.provider.split(',') : []
                this.locationFilter = query.location ? query.location.split(',') : []
                this.eventFilter = query.event ? query.event.split(',') : []
            }
        }
    },

    mounted() {
        this.loadPatients()
    },

    methods: {
        ...mapActions('provider', [
            'loadPatients',
            'loadPatientTickets',
        ]),
    },


    computed: {
        ...mapState('provider', [
            'overview'
        ]),
        ...mapState('provider', {
            tickets: state => state.tickets,
            ticketsConfig: state => state.ticketsConfig,
            providerPatients: state => state.providerPatients
        }),
        ...mapGetters('provider', [
            'getCurrentProvider',
            'getAllProviderPatientList'
        ]),
        url() {
            return `/upcoming/${this.direction}`
        },
        listTitle() {
            const topic = this.ticketsConfig.find((config) => config.id === this.topic)
            if(topic)
                return topic.title
            return ''
        },
        patientList() {
            if(this.timeRange.length > 0) {

                try {
                    let daysEvents

                    let upcomingDaysPatients = {}
                    if(this.overview && this.overview.schedule) {
                        // Filter for timeRange by looping over each key in `timeRange` add the events to `upcomingDaysPatients`
                        this.timeRange.forEach((day) => {
                            const currentEvents = this.overview.schedule[day],
                                finalEvents = {}
                            if(this.providerFilter.length > 0) {
                                // Filter for providerFilter by looping over each provider in `providerFilter` add the events to `finalEvents`
                                this.providerFilter.forEach((provider) => {
                                    finalEvents[provider] = currentEvents[provider]
                                })
                                upcomingDaysPatients[day] = finalEvents
                            }
                            else
                                upcomingDaysPatients[day] = currentEvents || {}
                        })
                    }

                    daysEvents = Object.values(upcomingDaysPatients).reduce((acc, curr) => {
                        acc = acc.concat(Object.values(curr))
                        return acc
                    }, []).flat()


                    let upcomiMappedSch = this.overview && this.overview.schedule_map
                    let daysEventsObj = daysEvents && daysEvents.map((eventId) => {
                        return upcomiMappedSch[eventId]
                    }).filter((evntObj) => {
                        if(this.eventFilter.length > 0) {
                            return this.eventFilter.includes(evntObj.event)
                        }
                        return true
                    }).filter((evntObj) => {
                        if(this.locationFilter.length > 0) {
                            return this.locationFilter.includes(formatUrlSafe(evntObj.location || 'other'))
                        }
                        return true
                    })

                    let filDaysEventsObj = daysEventsObj

                    let hasLocation = this.location && this.location !== 'undefined'

                    if (hasLocation) {
                        if (this.location === 'Other') {
                            filDaysEventsObj = daysEventsObj && daysEventsObj.filter((evntObj) => !evntObj.location)
                        } else {
                            filDaysEventsObj = daysEventsObj && daysEventsObj.filter((evntObj) => evntObj.location === this.location)
                        }
                    }

                    if(this.event) { 
                        if (hasLocation) { // has location and event both
                            if (this.location === 'Other') { // if the location is 'other'
                                filDaysEventsObj = daysEventsObj && daysEventsObj.filter((evntObj) => !evntObj.location && evntObj.event === this.event)
                            } else {
                                filDaysEventsObj = daysEventsObj && daysEventsObj.filter((evntObj) => evntObj.location === this.location && evntObj.event === this.event)
                            }
                        } else { // has only event
                            filDaysEventsObj = daysEventsObj && daysEventsObj.filter((evntObj) => evntObj.event === this.event)
                        }
                    }

                    let res2 = filDaysEventsObj && filDaysEventsObj.reduce((acc, curr) => {
                        if(acc.includes(curr.auth)) return acc
                        else {
                            acc.push(curr.auth)
                            return acc
                        }
                    },[])
                    return res2
                } catch(err) {
                    console.log(err)
                    return []
                }
            }
            return []
        }
    },

    components: {
        PopulationList
    }
}
</script>

<style>
.list {
	width: 240px;
	height: 100%;
	overflow-y: auto;
	float: left;
	border-right: solid 1px #dfdfdf;
}
.detail {
	height: 100%;
	overflow-y: auto;
}
.filter-view {
    padding: 10px;
    background: #fafafa;

    .el-card {
        margin-bottom: 10px;
    }
}
</style>
